import { useMemo, useState } from 'react'

import { useSelectedItemsList } from 'contexts/SelectedItemsListProvider'
import { useTranslate } from 'lib/tolgee'
import { analyticsTracker } from 'utils'

import { translations } from './edit-niche-modal.i18n'
import type { IBaseEditNicheModalViewProps } from './edit-niche-modal.types'

export const useEditNicheModalModel = (): IBaseEditNicheModalViewProps => {
  const { selectedItemsBar } = useSelectedItemsList()
  const t = useTranslate()

  const tabs = useMemo(() => {
    return [
      {
        value: 'rename',
        name: t(translations.renameTitle),
      },
      {
        value: 'group',
        name: t(translations.groupTitle),
        disabled: selectedItemsBar.length > 5,
      },
    ]
  }, [selectedItemsBar.length, t])

  const [activeTab, setActiveTab] = useState(tabs[0])

  const handleToggleTab = (tab: { name: string; value: string }) => {
    const entryPoint = selectedItemsBar.map(item => item?.name)
    const { NICHE_EDITING } = analyticsTracker.eventNames
    analyticsTracker.eventTrack(NICHE_EDITING.CHANGE_TAB, {
      tab: tab.value,
      Niches: entryPoint.join(', '),
    })
    setActiveTab(tab)
  }

  return { tabs, activeTab, handleToggleTab }
}
